
import React from 'react';
import { FlowRender } from "../flow-render";
import { Text, phoneValidator } from "../prm/text";
import { Name } from "../prm/name";
import {RadioButton} from "../prm/radio-button";
import { OptionMenu } from "../prm/option-menu";
import { CommunityPropertyMenu } from "./community-property-state-menu";
import { UgmaStateMenu } from "./ugma-state-menu";
import {Action, GreyBox} from "../../client/funcs/utils";
import { Popup } from "../onboarding-shared/popup";
import { renderPopup as renderCommunityStatePopup } from "../onboarding-tda/community-state-popup";
import { onPctAction } from "./co-owner-pct-onAction";
import {UploadFiles, init_state, isFilledElseHighlight } from "../onboarding-shared/widgets/uploader";
import {ROOT} from "../fake";
import {sprintf} from "sprintf-js";
import {InvestmentAccountType} from "../proto/investment_accounts";
import {XFER_IRA_TYPE, XFER_ACCT_TYPE} from "./shared-prms";

const xfer_firm_name = new Text(
  new Name("xfer_firm_name", "Name of Delivering Firm"), null,
  { path: "company.companyName"});

const xfer_firm_phone = new Text(
  new Name("xfer_firm_phone", "Delivering Firm Telephone Number"), null,
  { path: "phone.phoneNumber", arg0: "(###) ###-####" });
xfer_firm_phone.setValidator(phoneValidator);

const acct_name = new Text(
  new Name("acct_name", "Account Name/Title"));

const acct_number = new Text(
  new Name("acct_number", "Account Number"), null,
  { path: "finance.accountTemplate", arg0: "###-########-###"});

const full_xfer_text = "Full Transfer of Securities and Cash";
const xfer_ugma_state = new UgmaStateMenu(
  new Name("xfer_ugma_state"));

const xfer_age_menu = new OptionMenu(
  new Name("xfer_age_menu"),
  [ new Name("na", "N/A")]);

const must_agree = new RadioButton(
  new Name("must_agree"),
  [
    new Name("must_agree", "Must agree"),
  ]
);
must_agree.do_checkbox = true;


const simple_ira_funded = new RadioButton(
  new Name("simple_ira_funded"),
  [
    new Name("no", "No"),
    new Name("yes", "Yes"),
  ]);


const xfer_tenant_owner_pct = new Text(
  new Name("xfer_tenant_owner_pct"), "50");

const xfer_tenant_co_owner_pct = new Text(
  new Name("xfer_tenant_co_owner_pct"), "50");

const check_style_0 = {
    marginTop: "0.25rem"
};

const div_style = {
    marginBottom: "1rem"
}

const community_text = "Married Community Property (Designate State)";
const transfer_community_property_state = new CommunityPropertyMenu(
  new Name("transfer_community_property_state"));

const xfer_age_text = 'The age the child will take control';

const renderPopup = cb => {

  const text = "If you have any questions, please contact us.";
  const div_style = {
    textAlign: "center",
    padding: "1rem",
  };
  const button_style = {
    padding: "0.5rem 2rem",
  }

  return (
    <Popup translate_y={"-7rem"}>
      <div style={{ textAlign: "center"}}>
        <div style={div_style}>
          {text}
        </div>
        <Action style={button_style} onClick={cb}>
          Ok
        </Action>
      </div>
    </Popup>
  );
};

const UPLOAD_PREFIX = "bank_statements";
const UPLOAD_ERROR_PROP = UPLOAD_PREFIX + "_error";

class AccountTransfer extends FlowRender {

  constructor(index) {
    super(index, [
      acct_number,
      acct_name,
      xfer_firm_name,
      xfer_firm_phone,
      must_agree,
      XFER_ACCT_TYPE,
      XFER_IRA_TYPE,
      simple_ira_funded,
      transfer_community_property_state,
      xfer_tenant_owner_pct,
      xfer_tenant_co_owner_pct,
      xfer_ugma_state,
      xfer_age_menu,
    ]);
    XFER_ACCT_TYPE.onChangeCallback = this.onChange;
    XFER_IRA_TYPE.onChangeCallback = this.onChange;
    simple_ira_funded.onChangeCallback = this.onChange;

    xfer_tenant_owner_pct.onAction = onPctAction(xfer_tenant_owner_pct, xfer_tenant_co_owner_pct);
    xfer_tenant_co_owner_pct.onAction = onPctAction(xfer_tenant_owner_pct, xfer_tenant_co_owner_pct);

    xfer_ugma_state.setOnChangeCallback(this.onChange);
    xfer_ugma_state.setAgeMenu(xfer_age_menu);

    must_agree.onChangeCallback = this.onChange;
    acct_number.onChangeCallback = this.onChange;
    xfer_firm_name.onChangeCallback = this.onChange;

    transfer_community_property_state.onMouseEnterCallback = this.onMouseEnter;
    this.url = "account_transfer";
  }

  init(componentState, appState) {
    super.init(componentState, appState);
    componentState.show_popup = false;
    componentState.state_popup = false;
    componentState[UPLOAD_ERROR_PROP] = "";
    init_state(UPLOAD_PREFIX, appState, componentState);
  }

  onMouseEnter = (component, enter) => {
    component.setState({
      state_popup: enter,
    });
  };

  onChange = (component, newState) => {
    const tenants_in_common = XFER_ACCT_TYPE.isItemClicked(3, newState);
    xfer_tenant_owner_pct.setDisabled(newState, !tenants_in_common);
    xfer_tenant_co_owner_pct.setDisabled(newState, !tenants_in_common);

    if (must_agree.isClicked(component.state) !== must_agree.isClicked(newState)) {
      // Only apply the popup logic if the user actually clicked
      newState.show_popup = !must_agree.isClicked(newState);
    }

    const is_trust_enabled = XFER_ACCT_TYPE.isItemClicked(5, newState);
    xfer_ugma_state.setDisabled(newState, !is_trust_enabled);
    xfer_ugma_state.updateAgeMenu(component, newState);

    const is_simple_enabled = XFER_IRA_TYPE.isItemClicked(4, newState);
    simple_ira_funded.setDisabled(newState, !is_simple_enabled);
  };

  calc_account_type = component => {
    const acct_type = XFER_ACCT_TYPE.getValue(component.state, true);
    const ira_type = XFER_IRA_TYPE.getValue(component.state, true);
    if (acct_type === "individual") {
      return InvestmentAccountType.individual.id;
    } else if (acct_type === "joint_spouse"
      || acct_type === "joint_tenants" || acct_type === "tenants_common") {
      return InvestmentAccountType.joint.id;
    } else if (acct_type === "trust") {
      return InvestmentAccountType.ugma_utma.id;
    } else if (acct_type === "ira") {
      if (ira_type === "traditional_ira") {
        return InvestmentAccountType.ira.id;
      } else if (ira_type === "rollover_ira") {
        return InvestmentAccountType.rollover_ira.id;
      } else if (ira_type === "roth_ira") {
        return InvestmentAccountType.roth_ira.id;
      } else if (ira_type === "sepp_ira") {
        return InvestmentAccountType.sepp_ira.id;
      } else if (ira_type === "simple_ira") {
        return InvestmentAccountType.simple_ira.id;
      }
    }
    return null;
  }

  canNavigateNext(component) {
    const state = component.state;
    const highlight_rects = [];
    let num_roles = 1;
    let role_names = [ "Individual"];
    let num_id_docs = 1;
    let account_type;

    [ xfer_firm_name, xfer_firm_phone, acct_number, acct_name, XFER_ACCT_TYPE, must_agree
    ].forEach(text => text.isFilledElseHighlight(state, highlight_rects));

    const is_ira_clicked = XFER_ACCT_TYPE.isItemClicked(4, state);
    if (is_ira_clicked) {
      XFER_IRA_TYPE.isFilledElseHighlight(state, highlight_rects);
    }
    const is_simple_clicked = XFER_IRA_TYPE.isItemClicked(4, state);
    if (is_simple_clicked) {
      simple_ira_funded.isFilledElseHighlight(state, highlight_rects);
    }

    isFilledElseHighlight(UPLOAD_PREFIX, component, highlight_rects);

    if (highlight_rects.length > 0) {
      component.setState({
        highlight_rects: highlight_rects,
      });

      return null;
    }

    const acct_type = XFER_ACCT_TYPE.getValue(state, true);
    if (acct_type === "individual") {
      account_type = InvestmentAccountType.individual.id;
    } else if (acct_type === "ira") {
      const ira_type = XFER_IRA_TYPE.getValue(state, true);
      if (ira_type === "traditional_ira") {
        account_type = InvestmentAccountType.ira.id;
      } else if (ira_type === "rollover_ira") {
        account_type = InvestmentAccountType.rollover_ira.id;
      } else if (ira_type === "roth_ira") {
        account_type = InvestmentAccountType.roth_ira.id;
      } else if (ira_type === "sepp_ira") {
        account_type = InvestmentAccountType.sepp_ira.id;
      } else if (ira_type === "simple_ira") {
        account_type = InvestmentAccountType.simple_ira.id;
      }

    } else if (acct_type === "trust") {
      num_roles = 2;
      role_names = [ "Custodian", "Minor" ];
      num_id_docs = 2;
      account_type = InvestmentAccountType.ugma_utma.id;
    }
    const new_onboarding = {
      NUM_ROLES: num_roles,
      ROLE_TITLES: role_names,
      NUM_ID_DOCS: num_id_docs,
      account_type: account_type,
    }

    if (acct_type === "trust") {
      // Set the minor employment to be 'student'
      new_onboarding.employment_1_status = [ "employment_1_status|student"];
    }

    component.writeIfDirty(new_onboarding);

    const index = component.getOnboardingIndex();
    component.writeIfDirty({
      account_type: this.calc_account_type(component),
    })
    return component.getRootUrl() + (index === 0 ? "/personal_info" : "/authorization_0");
  };

  onNewProps(component, newState, newProps) {
    init_state(UPLOAD_PREFIX, component.getOnboardingData(newProps), newState);
  }

  setRandomValues(state, component) {
    super.setRandomValues(state, component);
    acct_name.setValue(state, Math.random() > 0.5 ? "Checking" : "Savings");

    const acct_type = XFER_ACCT_TYPE.getValue(state, true);
    if (acct_type === "tenants_common") {
      const pct = ROOT.random.num(10, 90, 5);
      xfer_tenant_owner_pct.setValue(state, sprintf("%d", pct));
      xfer_tenant_co_owner_pct.setValue(state, sprintf("%d", 100 - pct));
    } else if (acct_type === "ira") {
      XFER_IRA_TYPE.setRandomSingleValue(state);
      if (XFER_IRA_TYPE.getValue(state, true) === "simple_ira") {
        simple_ira_funded.setRandomSingleValue(state);
      }
    } else if (acct_type === "trust") {
      xfer_ugma_state.randomStateMenu(state);
    }

  }

  okClicked = (component) => () => {
    component.setState({
      show_popup: false,
    });
  };

  renderFirm = component => {
    const checkStyle = {
      transform: "translateY(0.2rem)",
    };
    const show_popup = component.state.show_popup;

    const agree_elem = (
      <div style={{flex: "1"}}>
        { show_popup && renderPopup(this.okClicked(component)) }
        { must_agree.renderCheckbox(0, component, checkStyle) }
        { must_agree.renderLabel(0, component.state, {paddingLeft: "0rem"}) }
      </div>
    )

    const in_style = {
      width: "100%",
    }
    return (
      <GreyBox>
        <div>
          { xfer_firm_name.renderInputDiv(component, in_style, xfer_firm_name.name.label ) }
        </div>
        <div style={{ display: "flex"}}>
          <div style={{flex: "1" }}>
            { xfer_firm_phone.renderInputDiv(component, in_style, xfer_firm_phone.name.label)}
          </div>
          <div style={{flex: "1" }}>
          </div>
        </div>
        <div style={{height: "2rem"}}/>
        <div style={{display: "flex"}}>
          <div style={{flex: "1"}}>
            { acct_name.renderInputDiv(component, in_style, acct_name.name.label )}
          </div>
          <div style={{width: "1rem"}}/>
          <div style={{flex: "1"}}>
            { acct_number.renderInputDiv(component, in_style, acct_number.name.label )}
          </div>
        </div>
        <div style={{ height: "1rem"}}/>
        <div style={{ display: "flex"}}>
          <div style={{ flex: "1"}}>
            { full_xfer_text }
          </div>
          <div style={{width: "1rem"}}/>
          { agree_elem }
        </div>
      </GreyBox>
    );
  };

  renderCommunityProperty = component => {
    const divStyle = {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        margin: "1rem 0 1rem 4.5rem",
    }

    const spanStyle = {
      marginRight: "1rem"
    };

    const dropdown = component.state.state_popup ? renderCommunityStatePopup() : null;

    return (
      <div style={divStyle}>
        <span style={spanStyle}>{community_text}</span>
        { transfer_community_property_state.renderMenuDiv(component, null, dropdown) }
      </div>
    )
  };

  renderJointSpouse = component => {
    const is_selected = XFER_ACCT_TYPE.isItemClicked(1, component.state) && false;
    return (
      <div style={div_style}>
        { XFER_ACCT_TYPE.renderCheckboxLabel(1, component, check_style_0) }
        { is_selected && this.renderCommunityProperty(component) }
      </div>
    )
  };

  renderTenantsInCommon = component => {
    const is_selected = XFER_ACCT_TYPE.isItemClicked(3, component.state);
    const inputStyle = {
      marginRight: "0.5rem",
      width: "5rem",
      textAlign: "center",
    };
    const spanStyle = {};

    if (!is_selected) {
      spanStyle.color = "#AAA";
    }

    return (
      <div style={{display: "flex", alignItems: "center"}}>
        <div>
          {XFER_ACCT_TYPE.renderCheckbox(3, component, check_style_0)}
          {XFER_ACCT_TYPE.renderLabel(3, component.state)}
        </div>
        <div style={{ width: "3rem"}}/>
        <div style={{display: "flex"}}>
          {xfer_tenant_owner_pct.renderInputDiv(component, inputStyle, "% Owner")}
          {xfer_tenant_co_owner_pct.renderInputDiv(component, inputStyle, "% Co-Owner")}
        </div>
      </div>
    );
  };

  renderIRA = component => {
    const ira_type_style = {
      marginLeft: "2rem",
      marginTop: "1rem",
    }

    const item_style = {
      paddingBottom: "1rem",
      display: "flex",
    }

    const render_item = (prm, index, suffix) => {
      return (
        <div style={item_style}>
          <div>
            { prm.renderCheckbox(index, component) }
            { prm.renderLabel(index, component.state) }
          </div>
          <div>{ suffix }</div>
        </div>
      )
    }

    const simple_suffix = (
      <div style={{ marginLeft: "2rem", color: "#000"}}>
        <div>Has SIMPLE IRA been funded for at least two years?</div>
        <div style={{height: "1rem"}}/>
        { render_item(simple_ira_funded, 0) }
        { render_item(simple_ira_funded, 1) }
      </div>
    )

    const ira_type = (
      <div style={ira_type_style}>
        { render_item(XFER_IRA_TYPE, 0) }
        { render_item(XFER_IRA_TYPE, 1) }
        { render_item(XFER_IRA_TYPE, 2) }
        { render_item(XFER_IRA_TYPE, 3) }
        { render_item(XFER_IRA_TYPE, 4, simple_suffix) }
      </div>
    );

    const do_type = XFER_ACCT_TYPE.isItemClicked(4, component.state);

    return (
      <div style={{marginBottom: "1rem"}}>
        <div>
          { XFER_ACCT_TYPE.renderCheckbox(4, component, check_style_0) }
          { XFER_ACCT_TYPE.renderLabel(4, component.state) }
        </div>
        { do_type && ira_type }
      </div>
    )
  }

  renderAge = component => {
    const spanStyle = {
      marginRight: "1rem",
    };
    const divStyle = {
      marginTop: "1rem",
    }
    return (
      <div style={divStyle}>
        <span style={spanStyle}>{xfer_age_text}</span>
        { xfer_age_menu.renderMenu(component) }
      </div>
    );
  };
  renderTrust = component => {
    const is_trust_enabled = XFER_ACCT_TYPE.isItemClicked(5, component.state);

    return (
      <div style={{display: "flex"}}>
        <div style={{flex: "0.3"}}>
          { XFER_ACCT_TYPE.renderCheckbox(5, component, check_style_0) }
          { XFER_ACCT_TYPE.renderLabel(5, component.state) }
        </div>
        <div style={{flex: "0.7"}}>
          <span style={{paddingRight: "1rem"}}>State</span> { xfer_ugma_state.renderMenu(component) }
          <div>
            { is_trust_enabled && this.renderAge(component) }
          </div>
        </div>
      </div>
    )
  };

  renderUploader = component => {
    const title_style = {
      fontSize: "1.5rem",
    }
    const error_str = component.state[UPLOAD_ERROR_PROP];
    const title_container_style = {
      display: "flex",
    }
    const error_style = {
      color: "red",
    }
    return (
      <div>
        <div style={{height: "3rem"}}/>
        <div style={title_container_style}>
          <div style={title_style}>Most Recent Account Statement</div>
          <div style={{flex: "1"}}/>
          <div style={error_style}>{error_str}</div>
        </div>
        <GreyBox>
          <UploadFiles
            prefix={"bank_statements"}
            onboarding={component.getOnboardingData()}
            component={component}
          />
        </GreyBox>
      </div>
    )

  }

  renderBody = component => {
    const text_type = "Account Type";
    const type_style = {
      marginTop: "3rem",
      fontSize: "1.5rem",
    }
    return (
      <div>
        { this.renderFirm(component) }
        { this.renderUploader(component) }
        <div style={type_style}>{text_type}</div>
        <GreyBox>
          { XFER_ACCT_TYPE.renderCheckboxLabel(0, component, check_style_0, {}, null, {marginBottom: "1rem"}) }
          { /* this.renderJointSpouse(component) */}
          { /* XFER_ACCT_TYPE.renderCheckboxLabel(2, component, check_style_0, {}, null, {marginBottom: "1rem"}) */}
          { /* this.renderTenantsInCommon(component) */}
          { this.renderIRA(component) }
          { this.renderTrust(component) }
        </GreyBox>
      </div>
    )
  };

  render = component => {
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Account Transfer", "50%", "954476658")}
        { this.renderProgress(component) }
        { this.renderSingleColumn(
          this.renderBody(component), "50%")}
        { this.renderNextButtonRow(component, true) }
      </div>
    )
  }
}

export { AccountTransfer };
